import { Nav, NavItem, NavLink } from "reactstrap";
import { Href } from "../../../Utils/Constants";
import { isSystemConfigEnabled } from "../../../sharedFunctions/SystemConfig";
import { useLabels } from "../../../sharedFunctions/CommonLable";

type propsType = {
    basicTab: string;
    setBasicTab: (data: string) => void;
}

export default function ApprovalNav({ basicTab, setBasicTab }: propsType) {
    const getLabel = useLabels();
    const isGeofencingActive = isSystemConfigEnabled("enable_geo_fencing");
    const isPodActive = isSystemConfigEnabled("capture_pod");
    const isSupportActive = isSupportActiveConfig();
    const isClosingStockActive = isSystemConfigEnabled("capture_closing_stock");
    const isHolidayActive = isSystemConfigEnabled("holiday_approval_enable");

    function isSupportActiveConfig() {
        return isSystemConfigEnabled("support_capture");
    }

    return (
        <Nav tabs className='border-tab nav-info mb-0'>
            <NavItem>
                <NavLink href={Href} className={`nav-border txt-info tab-info ${basicTab === '1' ? 'active' : ''}`} onClick={(e) => { e.preventDefault(); setBasicTab('1'); }}><i className="icofont icofont-ui-home" />{`${getLabel('MTP')} Approval`}</NavLink>
            </NavItem>
            <NavItem>
                <NavLink href={Href} className={`nav-border txt-info tab-info ${basicTab === '2' ? 'active' : ''}`} onClick={(e) => { e.preventDefault(); setBasicTab('2'); }}><i className="icofont icofont-ui-message" />{`${getLabel('Leaves')} Approval`}</NavLink>
            </NavItem>
            <NavItem>
                <NavLink href={Href} className={`nav-border txt-info tab-info ${basicTab === '3' ? 'active' : ''}`} onClick={(e) => { e.preventDefault(); setBasicTab('3'); }}><i className="icofont icofont-man-in-glasses" />{`${getLabel('Expense')} Approval`}</NavLink>
            </NavItem>
            {isPodActive && (
                <NavItem>
                    <NavLink href={Href} className={`nav-border txt-info tab-info ${basicTab === '4' ? 'active' : ''}`} onClick={(e) => { e.preventDefault(); setBasicTab('4'); }}><i className="icofont icofont-file-text" />{`${getLabel('POD')} Approval`}</NavLink>
                </NavItem>
            )}
            {isPodActive && (
                <NavItem>
                    <NavLink href={Href} className={`nav-border txt-info tab-info ${basicTab === '5' ? 'active' : ''}`} onClick={(e) => { e.preventDefault(); setBasicTab('5'); }}><i className="icofont icofont-listine-dots" />{`${getLabel('POD')} Summary`}</NavLink>
                </NavItem>
            )}
            {isSupportActive && (
                <NavItem>
                    <NavLink href={Href} className={`nav-border txt-info tab-info ${basicTab === '6' ? 'active' : ''}`} onClick={(e) => { e.preventDefault(); setBasicTab('6'); }}><i className="icofont icofont-support" />{`${getLabel('Support')} Approval`}</NavLink>
                </NavItem>
            )}
            {isClosingStockActive && (
                <NavItem>
                    <NavLink href={Href} className={`nav-border txt-info tab-info ${basicTab === '7' ? 'active' : ''}`} onClick={(e) => { e.preventDefault(); setBasicTab('7'); }}><i className="icofont icofont-box" />{`${getLabel('Closing Stock')} Approval`}</NavLink>
                </NavItem>
            )}
            {isHolidayActive && (
                <NavItem>
                    <NavLink href={Href} className={`nav-border txt-info tab-info ${basicTab === '8' ? 'active' : ''}`} onClick={(e) => { e.preventDefault(); setBasicTab('8'); }}><i className="icofont icofont-sun-alt" />{`${getLabel('Holidays')} Approvals`}</NavLink>
                </NavItem>
            )}
            {isGeofencingActive && (
                <NavItem>
                    <NavLink href={Href} className={`nav-border txt-info tab-info ${basicTab === '9' ? 'active' : ''}`} onClick={(e) => { e.preventDefault(); setBasicTab('9'); }}><i className="icofont icofont-location-pin" />{`${getLabel('GeoFencing')} Approvals`}</NavLink>
                </NavItem>
            )}
        </Nav>
    )
}
